import { StageFailure } from './OpenAmInitialData';

export enum LoginView {
  Loader = 'loader',
  LoginForm = 'loginForm',
  SMSPhoneNumber = 'smsPhoneNumber',
  SMSCode = 'smsCode',
  MSISDNCode = 'msisdnCode',
  SMSCodeChange2FA = 'smsCodeChange2FA',
  MFAAuthenticatorCode = 'mfaAuthenticatorCode',
  // TODO this might not be used
  MFASMSCode = 'mfaSmsCode',
  YoloOtpStage = 'yoloOtpStage',
  SMSNumberSelector = 'smsNumberSelector',
  DeviceCode = 'deviceCode',
  DeviceCodeSuccess = 'deviceCodeSuccess',
  TestLogin = 'TestLogin',
  BorgMigration = 'borgMigration',
}

export enum StageFailureType {
  AccountInvalidCredentials = 'error-account-invalid-credentials',
  SubscriptioncheckSubscription = 'error-subscriptioncheck-subscription',
  SmsInvalidPhoneNumber = 'error-sms-invalid-phone-number',
  SmsInvalidSmsCode = 'error-sms-invalid-sms-code',
  TotpInvalidCode = 'error-totp-invalid-code',
  YolootpInvalidCode = 'error-yolootp-invalid-code',
  MsisdnInvalidCode = 'error-msisdn-verificator-invalid-code',
  MsisdnResendLimit = 'error-msisdn-verificator-resend-limit-exceeded',
  MsisdnRetryLimit = 'error-msisdn-verificator-retry-limit-exceeded',
  Blocked = 'error-msisdn-verificator-ip-blocked',
}

export type OpenAmStage = {
  error?: string;
  authId?: string;
  name?: string;
  view: LoginView;
  infoText?: string[];
  failure?: StageFailure;
};

export type InitParams = {
  forgottenPasswordLink?: string;
  registrationLink?: string;
  smsLoginLink?: string;
  socialProviders?: Array<{
    type: 'Google' | 'Facebook' | 'Apple';
    link: string;
  }>;
  captchaSiteKey?: string;
  captchaInvisible?: string;
  businessLoginLink?: string;
  residentialLoginLink?: string;
  closeWebViewLink?: string;
  videoChatLink?: string;
  registrationB2bLink?: string;
  registrationB2bInfoLink?: string;
  faqLink?: string;
  appLink?: string;
  helpLink?: string;
  regLink?: string;
  realm: string;
};
